import { render, staticRenderFns } from "./actSlider.vue?vue&type=template&id=f8603e04&scoped=true"
import script from "./actSlider.vue?vue&type=script&lang=js"
export * from "./actSlider.vue?vue&type=script&lang=js"
import style0 from "./actSlider.vue?vue&type=style&index=0&id=f8603e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8603e04",
  null
  
)

export default component.exports